<template>
  <div class="action-appointment-editor">
    <!-- Node Intro -->
    <div class="node-intro">
      <div class="node-icon">
        <!-- calendar_today icon -->
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M19 4H18V2H16V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V10H19V20ZM19 8H5V6H19V8ZM12 13H17V18H12V13Z" fill="#5587BC"/>
        </svg>
      </div>
      <p class="node-description">
        <span class="node-title">Making Appointment</span> will schedule an appointment with the patient caused the Trigger event.
      </p>
    </div>

    <!-- Info Message -->
    <InlineNotification
      theme="info"
      message="The appointment request will be sent to the patient's email with your schedule for the patient to select the meeting time."
      :with_close_btn="false"
    />

    <!-- Send Appointment Request Field -->
    <div class="input-section">
      <div class="input-field">
        <Label label="Send Appointment Request">
          <TextArea
            v-model="localFormData.requestMessage"
            placeholder="For example: Dear patient, please book a meeting with me via this link ..."
            size="medium"
            @input="handleInput"
          />
        </Label>
      </div>
    </div>

    <!-- Save Configuration Button -->
    <SaveConfigure :disabled="!isFormValid" @save-configuration="saveConfiguration" />
  </div>
</template>

<script>
import SaveConfigure from '@/components/workflow/SaveConfigure.vue';

export default {
  name: 'ActionAppointmentEditor',
  components: {
    SaveConfigure
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      localFormData: {
        requestMessage: this.data.requestMessage || ''
      }
    };
  },
  computed: {
    isFormValid() {
      return true;
    }
  },
  watch: {
    'data.requestMessage': {
      handler(newVal) {
        if (newVal !== this.localFormData.requestMessage) {
          this.localFormData.requestMessage = newVal || '';
        }
      }
    }
  },
  methods: {
    handleInput() {
      // Update the shared data instance directly
      this.data.requestMessage = this.localFormData.requestMessage;
    },
    saveConfiguration() {
      this.$emit('save', {
        requestMessage: this.localFormData.requestMessage,
        configured: true
      });
    }
  }
};
</script>

<style scoped>
.action-appointment-editor {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

/* Node Intro */
.node-intro {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  padding: 8px 16px;
  background: #E4F3F5;
  border-radius: 5px;
}

.node-icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.node-description {
  flex: 1;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 300;
  line-height: 18px;
  color: #5587BC;
  margin: 0;
}

.node-title {
  font-weight: 700;
}


/* Input Section */
.input-section {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.input-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.input-label {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #4A4A4A;
  height: 24px;
  display: flex;
  align-items: center;
}
</style>
